import {createSelector} from "reselect";
import {Route, RouteEntity} from "../../../model/route";
import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";

export type RouteSelectorProps = {
  regionId?: string
  companyId?: string;
  showDoNotUse?: boolean;
};

const getRegionIdParam = createParamSelector<RouteSelectorProps | undefined, string | undefined>(params => params?.regionId);
const getCompanyIdParam = createParamSelector<RouteSelectorProps | undefined, string | undefined>(params => params?.companyId);
const getShowDoNotUseParam = createParamSelector<RouteSelectorProps | undefined, boolean | undefined>(params => params?.showDoNotUse);

export const routeSelector = () => createSelector(
  [getUseQueryResultData<Route>],
  (data) => {
    return data ? transformRoute(data) : undefined;
  }
);

export const routesSelector = () => createSelector(
  [getUseQueryResultData<Route[]>, getRegionIdParam, getCompanyIdParam, getShowDoNotUseParam],
  (data, regionId, companyId, showDoNotUse) => {
    return selectRoutesAndTransform(
      data ?? [], {
        regionId: regionId,
        companyId: companyId,
        showDoNotUse: showDoNotUse
      }
    );
  }
);

export const transformRoute = (value: Route): RouteEntity => {
  return RouteEntity.from(value)
}

export const selectRoutes = (values?: Route[], selector?: RouteSelectorProps): Route[] => {
  if (!values) {
    return [];
  }

  return values.filter((e) => {
    let filterIn = true;

    if (selector?.regionId) {
      if (!e.regionId || e.regionId !== selector.regionId) {
        filterIn = false;
      }
    }

    if (selector?.companyId) {
      if (!e.companyId || e.companyId !== selector.companyId) {
        filterIn = false;
      }
    }

    const showDoNotUse = selector?.showDoNotUse ?? false;
    if (filterIn && !showDoNotUse && e.doNotUse) {
      filterIn = false;
    }

    return filterIn;
  });
};

export const selectRoutesAndTransform = (values?: Route[], selector?: RouteSelectorProps): RouteEntity[] => {
  const selected = selectRoutes(values, selector);
  return selected.map(transformRoute);
};
